import { collection, getDocs, query, where } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Scenario from '../../models/Scenario';

async function getScenariosByIds(
  scenariosIds: string[]
): Promise<Scenario[]> {
  try {
    const db = firestore;
    const usersCollection = collection(db, FirestoreCollections.scenarios);
    const scenarios: Scenario[] = [];

    if (scenariosIds.length === 0) {
      return scenarios;
    }

    const results = await getDocs(
      query(
        usersCollection,
        where('id', 'in', scenariosIds)
      )
    );

    results.docs.forEach((doc) => {
      scenarios.push(Scenario.fromFirestore(doc));
    });

    return scenarios;
  } catch (e) {
    console.log('error: ', e);
    throw new GetScenariosByIdsFailure();
  }
}

export class GetScenariosByIdsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getScenariosByIds;
